export default "__VITE_ASSET__Kl2GqNgM__"